export default "__VITE_ASSET__Biq25qrE__"